import { Base } from '@app/shared/models/base.model'
import { User } from '@app/modules/user/user.model'

export class OpportunityStatus extends Base {
  uuid: string = null
  name: string = null
  displayOrder: number = null
  // ---------------------------------------------------------------------------
  createdAt: Date = null
  updatedAt: Date = null
  deletedAt: Date = null
  createdByUuid: string = null
  createdByUser: User = null
  updatedByUuid: string = null
  updatedByUser: User = null

  /**
   * Properties with type Date
   */
  protected _dates: Array<string> = [
    'createdAt',
    'updatedAt',
    'deletedAt'
  ]

  /**
   * Constructor
   *
   * @param data Initial values
   */
  public constructor (data?: Partial<OpportunityStatus>) {
    super(data)
    this.init(data)
  }
}
